import React from 'react'
import { useContext } from 'react'
import { GlobalState } from '../../GlobalState'
import { useEffect } from 'react';
import { api } from '../../util/urlConfig';
import moment from 'moment';
import './supplierFeedbackNotifyComponent.css'
import { useState } from 'react';
import axios from '../../helpers/axios';

export default function CustomerFeedbackNotifyComponent({ id }) {
    const [cusFeedbackDetail, setCusFeedbackDetail] = useState(null);

    //Import Global State
    const state = useContext(GlobalState);
    const [allCustomers] = state.customerAPI.allCustomers;

    const getCustomer = (id) => {
        return allCustomers.filter(customer => customer.id === id);
    }

    useEffect(() => {
        getCustomer(id);
    }, [id, allCustomers])

    return (
        <>
            {
                cusFeedbackDetail ?
                    <div className='notify-main-container'>
                        <div className='notify-content-area'>
                            <img className='notify-img' src={cusFeedbackDetail.customer && cusFeedbackDetail.customer.upload_image ? api + "/" + cusFeedbackDetail.customer.upload_image.image_url : "/img/dummy_avatar.png"} alt="avatar" />
                            <div className='notify-content-detail'>
                                <div className='notify-name'>
                                    {
                                        cusFeedbackDetail.customer ? getCustomer(cusFeedbackDetail.customer.id)[0].first_name + " " + getCustomer(cusFeedbackDetail.customer.id)[0].last_name
                                            : cusFeedbackDetail.created_by ? cusFeedbackDetail.created_by.first_name + " " + cusFeedbackDetail.created_by.last_name : ""
                                    }
                                </div>


                                <div className='notify-subname'>{cusFeedbackDetail.note}</div>
                                <div className='notify-subname'>
                                    <i className='uil uil-clock'></i>
                                    <span>{moment(cusFeedbackDetail.created_at).format('DD-MM-YYYY')}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    : <></>
            }
        </>
    )
}
